export default __webpack_public_path__ + "static/media/pizza_project.ecb2908f.png";